<div
  class="container-fluid pt-5 pb-5 customGapping listingHero"
  [ngClass]="{
    restaurantHero: business === 'restaurant',
    beautyHero: business === 'beauty-spa'
  }"
>
  <div class="desktopHide mobileSort">
    <div class="row">
      <div
        class="col-md-12 mobileSearch"
        [ngClass]="{
          bgCustomPurple: business === 'restaurant'
        }"
      >
        <div class="input-group">
          <span class="input-group-text lightDarkPurple border-end-0">
            <img
              src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/location-pin.svg"
              class="img-fluid"
              alt="location-icon"
            />
            <span class="font16 font500 ms-1 styled-select">
              <input
                class="form-control customInput lightDarkPurple lightDarkPurple-focus border-0"
                list="datalistOptions2"
                placeholder="Type to search..."
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                name="searchText"
                [(ngModel)]="searchText"
                (keyup)="getNearBy()"
                (focus)="getNearBy()"
                autocomplete="off"
              />
              <ul
                class="dropdown-menu p-3"
                aria-labelledby="dropdownMenuButton1"
              >
                <li class="lightDarkPurple p-2 rounded customPurple">
                  <img
                    class="img-fluid"
                    src="../../../../assets/instaciti-new-img/Group 17.svg"
                    alt="location"
                  />
                  <span class="locationText" (click)="setCurrentLocation()"
                    >Detect current location</span
                  >
                </li>
                <ng-container>
                  <p class="font18 font500 customPurple mt-3">Popular cities</p>
                  <ng-container *ngFor="let city of popularCities">
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="selectPopularCity(city)"
                      >
                        <p class="listMuted mb-0">
                          {{ city.CityName }}
                        </p>
                      </a>
                    </li>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="searchText">
                  <p class="font18 font500 customPurple mt-3">
                    Nearby Location
                  </p>
                  <ng-container *ngFor="let city of nearby">
                    <li>
                      <a class="dropdown-item" (click)="selectNearByCity(city)">
                        <p class="listMuted mb-0">
                          {{ city.LocName }}
                        </p>
                      </a>
                    </li>
                  </ng-container>
                </ng-container>
              </ul>
            </span>
          </span>
          <input
            class="form-control customInput p-3 border-start-0 border-end-0"
            placeholder="Type to search..."
            (keyup)="search($event)"
            (focus)="search($event)"
            [matAutocomplete]="keywords"
            [(ngModel)]="selectedKeyWord.Keywd"
            [ngModelOptions]="{ standalone: true }"
          />
          <mat-autocomplete
            #keywords="matAutocomplete"
            (optionSelected)="onChange($event.option.value)"
          >
            <mat-option *ngFor="let item of searchResult" [value]="item">
              {{ item.Keywd }}
            </mat-option>
          </mat-autocomplete>
          <span class="input-group-text bg-white border-start-0"
            ><img
              src="../../../../assets/instaciti-new-img/Vector (5).svg"
              alt="location-icon"
            />
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-12 align-self-center">
      <h1 class="font500">{{ heading }}</h1>
      <p class="font26 font400">
        {{ subHeading }}
      </p>
    </div>
    <div class="col-md-6 col-12">
      <div class="float-right">
        <figure>
          <img [src]="bannerImgURL" alt="" class="img-fluid" />
        </figure>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid customGapping collectionBand mb-3">
  <div class="customCard pt-3 pb-3 ps-3 pe-3">
    <div class="scrollMenu">
      <button
        class="btn font16 btn-danger font500 ps-5 pe-5 text-center text-white me-3"
      >
        Collection 1
      </button>
      <button
        class="btn font16 btn-success font500 ps-5 pe-5 text-center text-white me-3"
      >
        Collection 2
      </button>
      <button
        class="btn font16 btn-primary font500 ps-5 pe-5 text-center text-white me-3"
      >
        Collection 3
      </button>
      <button
        class="btn font16 btn-warning font500 ps-5 pe-5 text-center text-white me-3"
      >
        Collection 4
      </button>
    </div>
  </div>
</div>
